<app-menu [hasChanges]="loadMenu"></app-menu>
<app-loading [show]="load"></app-loading>
<h3 class="uppercase ml-2">Creación y Actualización de Clientes</h3>
<section class="m-2">
    <form [formGroup]="formClient">
        <div class="flex flex-wrap">
            <div class="w-full md:w-6 p-2">
                <label class="pb-2">Tipo de identificación <span class="text-xs text-red-700">*</span></label>
                <p-dropdown [options]="listIdentificationType" optionLabel="descripcion" (onChange)="searchClient()"
                    placeholder="Tipo de identificación" formControlName="tipo" class=""></p-dropdown>
            </div>
            <div class="w-full md:w-6 p-2">

                <label class="pb-2">Nro. de identificación <span class="text-xs text-red-700">*</span>
                    <span class="text-xs" *ngIf="formClient.value.tipo?.idTipoIdentificacion ==3">
                        Ingrese la información sin puntos y sin dígito de verificación</span></label>
                <div class="p-inputgroup">
                    <input pInputText type="text" class="w-full " placeholder="Nro. de Identificación"
                        formControlName="identificacion" autocomplete="off" (blur)="searchClient()">
                    <div class="p-inputgroup-addon">
                        <label>{{digito??''}}</label>
                    </div>
                </div>
            </div>
            <div class="w-full text-center"><button pButton icon="pi pi-file-import" label="Volver a importar"
                    size="small" class="p-button p-button-outlined p-button-success"
                    (click)="this.searchClientExternSystem();"></button></div>
            <div class="w-full"><span [innerHTML]="messageClient"></span></div>
            <div class="w-full md:w-6 p-2" *ngIf="formClient.value.tipo?.idTipoIdentificacion ==3">
                <label class="pb-2">Razón Social <span class="text-xs text-red-700">*</span></label>
                <input pInputText type="text" class="w-full uppercase " placeholder="Razon Social"
                    formControlName="razonSocial" autocomplete="off">
            </div>
            <div class="w-full md:w-6 p-2">
                <label class="pb-2">Contacto <span class="text-xs text-red-700">*</span></label>
                <input pInputText type="text" class="w-full uppercase " placeholder="Nombres y Apellidos"
                    formControlName="nombres" autocomplete="off">
            </div>
            <div class="w-full md:w-6 p-2">
                <label class="pb-2">Correo electrónico <span class="text-xs text-red-700">*</span></label>
                <input pInputText type="text" class="w-full lowercase " placeholder="Correo Electrónico"
                    formControlName="correo">
            </div>
            <div class="w-full md:w-6 p-2">
                <label class="pb-2">Dirección</label>
                <input pInputText type="text" class="w-full " placeholder="Dirección" formControlName="direccion">
            </div>
            <div class="w-full md:w-6 p-2">
                <label class="pb-2">Departamento</label>
                <p-dropdown [options]="listDptos" optionLabel="nombreDepartamento" placeholder="Departamento"
                    formControlName="departamento" (onChange)="loadCities()" class=""></p-dropdown>
            </div>
            <div class="w-full md:w-6 p-2">
                <label class="pb-2 ">Ciudad</label>
                <p-dropdown [options]="listCities" optionLabel="nombreCiudad" placeholder="Ciudad"
                    formControlName="ciudad" class=""></p-dropdown>
            </div>
            <div class="w-full md:w-6 p-2">
                <label class="pb-2">Nro. de teléfono</label>
                <input pInputText type="text" class="w-full " placeholder="Nro. de celular" formControlName="telefono">
            </div>
            <div class="w-full md:w-6 p-2">
                <label class="pb-2 ">Sucursales</label>
                <p-dropdown [options]="listOfBrancheOffice" optionLabel="sucursal" placeholder="Sucursal"
                    formControlName="sucursal" class=""></p-dropdown>
                <span class="text-xs cursor-pointer" (click)="this.displaySucursal=true;">Incluir sucursal</span>
            </div>
        </div>
    </form>
    <div class="flex flex-wrap">
        <div class="w-full md:w-6 mt-2 p-2">
            <label class="pb-2">Canal de Ingreso</label>
            <p-dropdown [options]="listCanalIngreso" optionLabel="descripcion"
                placeholder="Seleccione el canal de ingreso" [(ngModel)]="selectedChannelIngreso"></p-dropdown>
        </div>
        <div class="w-full md:w-6 mt-2 p-2">
            <label class="pb-2">Lista de Precios</label>
            <p-dropdown [options]="listOfPrice" optionLabel="nombreListaPrecios"
                placeholder="Lista de precios a aplicar" [(ngModel)]="selectedListOfPrice"></p-dropdown>
        </div>
        <div class="w-full text-center mt-2">
            <button pButton icon="pi pi-check-circle mt-2" class="p-button p-button-success"
                label="Actualizar Información" (click)="saveInfoClient()"></button>
        </div>
    </div>
</section>
<!--Información de sistema alterno-->
<p-dialog header="Cargar información de sistema alterno" [(visible)]="displayInfoTercero" [modal]="true">
    <p>Se ha encontrado información en el sistema integrado, ¿Desea visualizar la
        información? </p>
    <div class="flex flex-row align-items-center"><button pButton label="SI" icon="pi pi-check-circle"
            (click)="fillFormClientExternSystem()" class="p-button p-button-success"></button> | <button pButton
            label="NO" icon="pi pi-times-circle" class="p-button p-button-danger"
            (click)="displayInfoTercero=false;"></button></div>
</p-dialog>

<!--Información de sistema alterno-->
<p-dialog [(visible)]="displaySucursal" [modal]="true">
    <ng-template pTemplate="header">
        <div class="flex flex-column">
            <h3 class="uppercase p-0 m-0">Adicionar sucursal</h3>
            <p class="p-0 m-0">Proceso según negociación para temas de facturación</p>
        </div>
    </ng-template>
    <div class="m-0 p-0">

        <ul class="list-disc" *ngFor="let item of listOfBrancheOffice">
            <li><span class="flex flex-row">Sucursal {{item.sucursal}} - &nbsp;<p-checkbox [binary]="true"
                        [(ngModel)]="item.activo" inputId="binary" />&nbsp;{{item.activo ? 'Activo'
                    :'Inactivo'}}</span>
            </li>
        </ul>
        <div class="w-full">
            <label class="p-2" for="idSucursal">Sucursal</label>
            <p-inputNumber id="idSucursal" [inputStyle]="{'width':'100%'}" class="w-full"
                placeholder="Ingrese el numero de sucursal"></p-inputNumber>
        </div>
        <div class="flex justify-content-end gap-2">
            <p-button label="Cerrar" severity="danger" (click)="displaySucursal = false" />
            <p-button label="Adicionar" severity="success"
                (click)="addSucursal()" />
        </div>
    </div>
</p-dialog>
<p-toast></p-toast>